/**
 * This file contains constants related to the customizer font styles
 *
 * All constants should be UPPERCASE.
 * All constants should be defined as const rather than let
 * All constants should be in alphabetical order.
 * All constants should be exported so other files can easily use them.
 */

 export const BOLD = 'bold';
 export const ITALIC = 'italic';
 export const NORMAL = 'normal';
 export const STRIKETHROUGH = 'strikethrough';
 export const UNDERLINE = 'underline';
